import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { approveTransfer, listTransfers, previewTransfer, requestTransfer } from "../../api/accounting";

const today = () => new Date().toISOString().slice(0, 10);

// المناقلات بين الفروع: ميزة مفعّلة لكل شركة من لوحة مالك المنصة (cash_transfers).
export const useTransfers = (enabled, afterApprove) => {
  const { t } = useTranslation();
  const [transfers, setTransfers] = useState([]);
  const [move, setMove] = useState({ from_cashbox_id: "", to_cashbox_id: "", amount: "" });
  const [plan, setPlan] = useState(null);

  const load = useCallback(async () => {
    if (!enabled) return;
    setTransfers(await listTransfers({ status: "all" }));
  }, [enabled]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const { from_cashbox_id, to_cashbox_id, amount, manual_rate } = move;
    if (!enabled || !from_cashbox_id || !to_cashbox_id || !Number(amount)) return setPlan(null);
    previewTransfer({
      from_cashbox_id,
      to_cashbox_id,
      amount: Number(amount),
      manual_rate: manual_rate ? Number(manual_rate) : undefined,
    })
      .then(setPlan)
      .catch(() => setPlan(null));
  }, [move, enabled]);

  const submit = async () => {
    await requestTransfer({
      ...move,
      date: today(),
      amount: Number(move.amount),
      manual_rate: move.manual_rate ? Number(move.manual_rate) : undefined,
    });
    toast.success(t("acct.transferRequested"));
    setMove({ ...move, amount: "", manual_rate: "" });
    load();
  };

  const approve = async (transfer) => {
    await approveTransfer(transfer.id);
    toast.success(t("acct.transferApproved"));
    load();
    afterApprove?.();
  };

  return { transfers, move, setMove, plan, submit, approve };
};
